import $ from 'jquery';

export default function getProperty($elem, name, og, def) {
    return $elem.data(name) ||                                       /* Property of current object */
        $elem.parent().data(name) ||                                 /* Property of parent */
        (og && $('meta[property="' + og + '"]').attr('content')) ||  /* OpenGraph meta-property */
        def;                                                         /* default value */
}
